<template>
  <div class="home-box1" :style="{ backgroundImage: `url(${bb})` }">
    <v-row
      class="d-flex align-center flex-row justify-center"
      style="min-height: 90vh;"
    >
      <v-row class="white-bg">
        <v-col
          cols="12"
          xs="12"
          md="6"
          :style="{ backgroundImage: `url(${newbb})` }"
          class="small-bg d-flex align-center justify-center"
        >
          <v-col class="px-10">
            <p
              class="d-none d-md-block text-h5 white--text font-weight-light"
              v-html="selectedQuote.text"
            ></p>
            <p
              class="d-md-none text-h6 white--text font-weight-light"
              v-html="selectedQuote.text"
            ></p>
            <p>
              <strong Class="font-weight-light font-italic">— {{ selectedQuote.author }}</strong>
            </p>
          </v-col>
        </v-col>
        <v-col cols="12" xs="12" md="6" class="form-section">
          <div v-if="showLogin" class="d-flex flex-column align-center">
            <img class="d-md-none" :src="logoSm" width="120px" alt="ProMate" />
            <img
              class="d-none d-md-block"
              :src="logoSm"
              width="180px"
              alt="ProMate"
            />
            <h2 class="d-none d-md-block text-h4 font-weight-medium mt-2">
              Login
            </h2>
            <h2 class="d-md-none text-h5 font-weight-medium mt-2">Login</h2>
            <v-col class="mt-5 px-7">
              <v-layout row v-if="errors">
                <v-row>
                  <Alert @dismissed="onDismissed" :text="errors"></Alert>
                </v-row>
              </v-layout>
              <v-progress-linear
                v-if="loading"
                indeterminate
                color="#00B3FF"
              ></v-progress-linear>
            </v-col>
            <v-col>
              <v-form>
                <v-text-field
                  outlined
                  dense
                  ame="username"
                  label="Email or Mobile Number"
                  v-model="username"
                  @keydown.enter="login"
                  hint="If mobile, enter without 0 (777xxxxxx)"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="password"
                  id="password"
                  name="password"
                  label="Password"
                  @keydown.enter="login"
                  :type="visible ? 'text' : 'password'"
                  placeholder="Enter Password"
                  :append-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append="visible = !visible"
                  outlined
                  dense
                ></v-text-field>
              </v-form>
            </v-col>
            <v-col>
              <v-btn
                dark
                color="#00B3FF"
                block
                @click="login1"
                :loading="loading"
                depressed
                >LOGIN</v-btn
              >
              <v-row class="d-flex align-center justify-center my-5">
                <v-btn
                  class="text-none"
                  text
                  @click="login"
                  :disabled="loading"
                  depressed
                  link
                  to="/forgot-password"
                  >Forgot Password?</v-btn
                >
              </v-row>
            </v-col>
          </div>
        </v-col>
      </v-row>
    </v-row>
  </div>
</template>

<script>
import Alert from "@/components/shared/Alert";
import { mapGetters } from "vuex";
import { AuthService } from "../../services/auth-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "Login",
  components: { Alert },
  data() {
    return {
      errors: null,
      loading: false,
      username: this.$route.query.email || "",
      password: "",
      showLogin: true,
      bb: require("@/assets/img/bb.jpg"),
      newbb: require("@/assets/img/newbb.jpg"),
      logo: require("@/assets/logo.png"),
      logoSm: require("@/assets/logo_sm.png"),
      visible: false,
      quotes: [
        {
          text:
            "Being a Project Manager is like being an artist,<br>you have the different colored process streams<br>combining into a work of art.",
          author: "Greg Cimmarrusti",
        },
        {
          text:
            "Operations keep the lights on,<br>strategy provides a light at the end of the tunnel,<br>but project management is the train engine that moves the organization forward.",
          author: "Joy Gumz",
        },
        {
          text:
            "Every project is an opportunity to learn,<br>to figure out problems and challenges,<br>to invent and reinvent.",
          author: "David Rockwell",
        },
        {
          text: "A good system shortens the road to the goal.",
          author: "Orison Sweet Marden",
        },
      ],
      selectedQuote: {},
    };
  },
  mounted() {
    this.onDismissed();
    this.selectDailyQuote();
  },
  computed: {
    ...mapGetters("auth", {
      errors: "errors",
      isLogged: "token",
      loading: "loading",
      profile: "profile",
    }),
  },
  methods: {
    selectDailyQuote() {
      const today = new Date();
      const dayOfYear = Math.floor(
        (today - new Date(today.getFullYear(), 0, 0)) / 1000 / 60 / 60 / 24
      );
      const quoteIndex = dayOfYear % this.quotes.length;
      this.selectedQuote = this.quotes[quoteIndex];
    },
    login1() {
      this.errors = null;
      let data = {
        username: this.username,
        password: this.password,
      };
      this.loading = true;
      AuthService.login1(data)
        .then((response) => {
          if (response.status == 200) {
            if (response.data.user.enable_auth == 0) {
              this.login();
            } else {
              this.loading = false;
              this.$store.dispatch("auth/setUsername", this.username);
              this.$store.dispatch("auth/setPassword", this.password);

              this.showLogin = false;
              this.$router.push("/googleAuth");
            }
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    login() {
      this.$store
        .dispatch("auth/retrieveToken", {
          username: this.username,
          password: this.password,
        })
        .then((response) => {
          if (response.status == 200) {
            this.loading = false;
            this.showLogin = false;
            if (response.data.roles && response.data.roles.length > 0) {
              this.$router.push("/switch-role");
            } else {
              this.$router.push("/");
            }
          }
        });
    },

    onDismissed() {
      this.$store.dispatch("auth/clearError");
    },
  },
};
</script>

<style>
.login-page {
  padding-bottom: 0px;
}

.boarder {
  border-radius: 10px;
}

.home-box1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
}

.white-bg {
  background-color: none;
  border-radius: 15px;
  min-height: 575px;
  margin: 0px 15%;
  padding: 0;
  overflow: hidden;
}

.img {
  position: absolute;
  border-radius: 15px;
  height: 560px;
  width: 520px;
}

.img1 {
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  overflow: hidden;
  width: 515px;
}

.small-bg {
  background-size: cover;
  background-position: center;
  overflow: hidden;
}

.form-section {
  background-color: white;
  padding-left: 8%;
  padding-right: 8%;
  padding-top: 50px;
  padding-bottom: 32px;
}
</style>
